import { isMimeType } from "../../files/is-mime-type.js";
import { isUploadedFile } from "../../files/is-uploaded-file.js";
export function uploadedFileField(opts) {
    return (value) => {
        if (opts.required && !value)
            return {
                isValid: false,
                error: opts.message,
            };
        if (value == undefined) {
            return {
                isValid: true,
                value: undefined,
            };
        }
        if (!isUploadedFile(value)) {
            return {
                isValid: false,
                error: opts.message,
            };
        }
        if (opts.acceptMimeTypes &&
            !opts.acceptMimeTypes.some((mt) => isMimeType(mt, value.mimeType))) {
            return {
                isValid: false,
                error: opts.message,
            };
        }
        if (opts.maxSizeInBytes && value.sizeInBytes > opts?.maxSizeInBytes) {
            return {
                isValid: false,
                error: opts.message,
            };
        }
        return {
            isValid: true,
            value: value,
        };
    };
}
